<template>
  <el-table-column
    prop="own_company.name"
    sortable="custom"
    label="Saját cég"
    show-overflow-tooltip
    min-width="150"
  >
    <template slot-scope="scope">
      <span v-if="scope.row.own_company">{{ scope.row.own_company.name }}</span>
      <span v-else>-</span>
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'own_company.name',
  };
</script>
